import React from 'react';
import I18n from 'i18n-js';

import CsrfForm from '../csrf_form';
import { APPLE_AUTH_PATH } from '../url_helpers';
import AppleIcon from '@reverbdotcom/cadence/icons/core/apple.svg?component';
import { RCTextWithIcon, RCButton } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '../elog/mparticle_tracker';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function AppleSigninButton(props: Props) {
  const id = 'apple-signup-signin';

  const title = props.isSignup
    ? I18n.t('commons.signupForm.appleSignUp')
    : I18n.t('commons.signupForm.appleSignIn');

  function trackAppleSigninButtonClick() {
    trackEvent({
      componentName: 'AppleSigninButton',
      eventName: MParticleEventName.ClickedAppleSigninButton,
    });
  }

  return (
    <CsrfForm
      id={id}
      method="post"
      action={APPLE_AUTH_PATH.expand({ redirect_to: props.redirectTo })}
    >
      <RCButton
        isSubmit
        fullWidth
        form={id}
        variant="primary"
        onClick={trackAppleSigninButtonClick}
      >
        <RCTextWithIcon
          svgComponent={AppleIcon}
          placement="left"
          size="large"
        >
          {title}
        </RCTextWithIcon>
      </RCButton>
    </CsrfForm>
  );
}
